
$('.plan-subscription').on('click',function(){
  var planId = $(this).attr("data-plan-id");
  if(planId){
    $('.selling__plan-set-value').attr('name', 'selling_plan').val(planId);
  }
  $('.plan-one-time .single-product__plan-details-item:first-child .variant-option-value').prop('checked', true).trigger('change');
  $('.sticky-bottom-bar__product-info p').text($(this).find("h6").text());

  var selected_plan_price = $('.the-plan-inp:checked').next().find('p').html();
  $('.sticky-bottom-bar__product-price').html(selected_plan_price);
});
$('.plan-one-time').on('click',function(){
  $('.selling__plan-set-value').attr('name', '');
  $(this).find('.first-price').hide();
  $(this).find('.first-price').next().show();
  $('.prod-cart-quantity').val(1);
  $('.sticky-bottom-bar__product-info p').text($(this).find("h6").text());
  var selected_plan_price = $('.the-plan-inp:checked').next().find('p').html();
  $('.sticky-bottom-bar__product-price').html(selected_plan_price);
});


setTimeout(function () {
  var selected_plan_price = $('.the-plan-inp:checked').next().find('p').html();
  var selected_plan_title = $('.the-plan-inp:checked').next().find('.single-product__plan-title h6').text();
  $('.sticky-bottom-bar__product-price').html(selected_plan_price);
  $('.sticky-bottom-bar__product-info p').text(selected_plan_title);
}, 300);

const productContent = document.querySelector('.single-product__content');
const stickyBar = document.querySelector('.sticky-bottom-bar');

if (productContent && stickyBar) {
  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      stickyBar.classList.toggle('active', !entry.isIntersecting);
    });
  }, {
    threshold: 0
  });

  observer.observe(productContent);
}


$('.single-product__add-btn').click(function(e){
  e.preventDefault();
  
  var $sectionRoot = $(this).closest('.single-product__inner');
  var $form = $sectionRoot.find('.single-product-form').first();
  if (!$form.length) {
    $form = $('.single-product-form').first();
  }
  var formData = $form.serialize();
  var $freeProductInput = $form.find('input[name="free_product"]');
  var $selectedFreeGift = $sectionRoot.find('.free-gift-variant-option:checked');
  var freeProductVal = '';

  if ($selectedFreeGift.length && $selectedFreeGift.attr('data-free-variant-available') === 'true') {
    freeProductVal = $selectedFreeGift.val();
    if ($freeProductInput.length) {
      $freeProductInput.val(freeProductVal);
    }
  } else if ($freeProductInput.length) {
    freeProductVal = $freeProductInput.val();
  }

  if ($freeProductInput.length && freeProductVal) {
    // Free gift injection: extend existing add-to-cart payload with a second line item.
    var mainProductId = $form.find('select[name="id"]').val();
    var mainProductQty = $form.find('input[name="quantity"]').val() || 1;
    var postData = {
      items: [
        {
          id: mainProductId,
          quantity: mainProductQty
        },
        {
          id: freeProductVal,
          quantity: 1,
          properties: {
            _free_gift: 'true'
          }
        }
      ]
    };
    // Add selling_plan if set
    var sellingPlan = $form.find('.selling__plan-set-value[name="selling_plan"]').val();
    if (sellingPlan) {
      postData.items[0].selling_plan = sellingPlan;
    }
    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      dataType: 'json',
      contentType: 'application/json; charset=utf-8',
      data: JSON.stringify(postData),
      success: function(data) {
          window.location.href = "/cart";
      },
      error: 'addToCartFail'
    });
  } else {
    // Only add main item
    $.ajax({
      type: 'POST', 
      url: '/cart/add.js',
      dataType: 'json', 
      data: formData,
      success: function(data) {
        window.location.href = "/cart";
      },
      error: 'addToCartFail'
    });
  }
});

$(document).on('click', '.upsell-atc-btn', function(e){
  e.preventDefault();
  $.ajax({
    type: 'POST', 
    url: '/cart/add.js',
    dataType: 'json', 
    data: $(this).closest('.upsell-product-form').serialize(),
    success: function(data) {
      sectionRendering();
    },
    error: 'addToCartFail'
  });
});

$(document).on('click', '.upsell-atc-btn-cart', function(e){
  e.preventDefault();
  $.ajax({
    type: 'POST', 
    url: '/cart/add.js',
    dataType: 'json', 
    data: $(this).closest('.upsell-product-form').serialize(),
    success: function(data) {
      window.location.href = "/cart";
    },
    error: 'addToCartFail'
  });
})

$(document).on('change', '.free-gift-variant-option', function() {
  var $option = $(this);
  var $sectionRoot = $option.closest('.single-product__inner');
  var $form = $sectionRoot.find('.single-product-form').first();
  var $freeInput = $form.find('input[name="free_product"]');
  if (!$freeInput.length) return;

  if ($option.attr('data-free-variant-available') === 'true') {
    $freeInput.val($option.val());
  } else {
    $freeInput.val('');
  }
});


function sectionRendering() {
  fetch("?section_id=main-product")
    .then((res) => res.text())
    .then((data) => {
      var upsell__html = $(data);
      var render__html = $(".upsell-selectors", upsell__html);
      $(".upsell-selectors").replaceWith(render__html);
    });
}

function removeItemPdpp(e , el){
  e.preventDefault();
  var variant_id = $(el).attr('data-id');
  var data = { updates: {} };
  data.updates[variant_id] = '0';
  jQuery.ajax({
    type: 'POST',
    url: '/cart/update.js',
    data: data,
    dataType: 'json',
    success: function(res) {
      get_pdp_details();
      sectionRendering();
    }
  });
}

function getSelectedOptionValues() {
  var selectedByPosition = {};
  $(".variant-option-value:checked").each(function () {
    var position = parseInt($(this).data("option-position"), 10);
    if (position) {
      selectedByPosition[position] = $(this).val().trim();
    }
  });
  var optionCount = parseInt($("#single_product").attr("data-option-count"), 10) || 0;
  if (!optionCount) {
    return null;
  }
  var orderedValues = [];
  for (var i = 1; i <= optionCount; i++) {
    if (!selectedByPosition[i]) {
      return null;
    }
    orderedValues.push(selectedByPosition[i]);
  }
  return orderedValues;
}

function selectedVarint(variantId) {
  if (!variantId) {
    return;
  }
  var url = new URL(window.location.href);
  url.searchParams.set("variant", variantId);
  window.history.replaceState({}, "", url);
}

function matchVariant() {
  var selectedValues = getSelectedOptionValues();
  if (!selectedValues) {
    return;
  }
  var updateValue = selectedValues.join(" / ");
  var matched = false;
  $("#single_product option").each(function () {
    var optionValue = $(this).text().trim();
    if (updateValue.toLowerCase() === optionValue.toLowerCase()) {
      $(this).prop("selected", true);
      matched = true;
      var variant__available = $(this).attr("data-variant-available");
      var prod_price = $(this).attr("var-price");
      $('.plan-one-time .single-product__plan-title p').html(prod_price);
      if(variant__available == 'false'){
          $(".single-product__btn-add").addClass("btn_disabled")
          $(".single-product__btn-add").text("BACK SOON");
      }else{
          $(".single-product__btn-add").removeClass("btn_disabled"); 
          $(".single-product__btn-add").text("Add to cart");
          $('.single-product__btn-add_daily').text("Start my Daily Deeply routine");
      }
      selectedVarint($(this).val());
      return false;
    }
  });
  if(!matched){
    $(".single-product__btn-add").addClass("btn_disabled").text("BACK SOON");
  }
}

$(".variant-option-value").change(function () {
  matchVariant();
  var the_price = $(this).parent().parent().parent().parent().find('.single-product__plan-title p').html();
  $('.sticky-bottom-bar__product-price').html(the_price);
})
matchVariant();

function increment(el) {
  var input = el.previousElementSibling.querySelector('input');
  var value = parseInt(input.value);
  value = isNaN(value) ? 0 : value
  value++;
  input.value = value;
  changeQuantity(input);
}

// decrement quantity in cart drawer
function decrement(el) {
  var input = el.nextElementSibling.querySelector('input');
  var value = parseInt(input.value);
  if (value > 1) {
    value = isNaN(value) ? 0 : value;
    value--;
    input.value = value;
    changeQuantity(input);
  }
}

function changeQuantity(input) {
  var quantity = $(input).val();
  $('.single-product__plan-details-quan input').val(quantity);
  $('.prod-cart-quantity').val(quantity);
  // var price = $('.single-product__plan-details-quan input').attr('price') * quantity;
  // var com_price = $('.single-product__plan-details-quan input').attr('com-price') * quantity;
  // $('.plan-subscription .single-product__plan-title p span').text('£' + price / 100);
  // $('.plan-subscription .single-product__plan-title p del').text('£'+com_price / 100);
}

// Remove
function removeItem_cart(e , el){
  e.preventDefault();
  var variant_id = $(el).attr('data-id');
  console.log(variant_id);
  var data = { updates: {} };
  data.updates[variant_id] = '0';
  jQuery.ajax({
    type: 'POST',
    url: '/cart/update.js',
    data: data,
    dataType: 'json',
    success: function(res) {
      get_cart_details_1();
    }
  });
}

// cart render
function get_cart_details_1(){
  fetch("?section_id="+ sectionID)
    .then((response) => response.text())
    .then((cartData) => {
      var cart_html = $(cartData);
      var cart_items = $(".cart__inner", cart_html);
      $(".cart__inner").replaceWith(cart_items);
    });
};

// Increase and decrease
function increaseItemCount_1(e, el) {
  var $input = el.previousElementSibling;
  var value = parseInt($input.value, 10);
  value = isNaN(value) ? 0 : value;
  value++;
  $input.value = value;            
  change_qty_1($input);
}

function decreaseItemCount_1(e, el) {
  var $input = el.nextElementSibling;
  var value = parseInt($input.value, 10);
  if (value > 1) {
      value = isNaN(value) ? 0 : value;
      value--;
      $input.value = value;            
      change_qty_1($input);
  }
}

// change quantity
function change_qty_1($input){
  var variant_id = $($input).attr("data-id");
  var quantity= $($input).val();          
  var data = { updates: {} };
  data.updates[variant_id] = quantity;
  jQuery.ajax({
    type: 'POST',
    url: '/cart/update.js',
    data: data,
    dataType: 'json',
    success: function(res) {               
      get_cart_details_1();
    }
  });
};